import { createStyles } from '@material-ui/core';
import palette from 'theme/palette';

export default () =>
  createStyles({
    lowImpact: {
      color: palette.dashGreen,
      fontSize: 13,
      marginRight: 2,
      transform: 'rotate(90deg)',
    },
    mediumImpact: { color: palette.dashYellow, fontSize: 13, marginRight: 2 },
    highImpact: {
      color: palette.dashRed,
      fontSize: 13,
      transform: 'rotate(270deg)',
      marginRight: 2,
    },
    impactGrid: { display: 'flex', alignItems: 'center' },
  });
